import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const GROUPEDORDERMODALLAUNCHERBLOCK_LEGACY_FIELD_ORDER = [];

const {
  groupedOrderModalLauncherBlockDescriptor: _generatedGroupedOrderModalLauncherBlockDescriptor,
  groupedOrderModalLauncherBlockBlocDefinition,
  groupedOrderModalLauncherBlockDashboardLayout,
  groupedOrderModalLauncherBlockConfig,
  groupedOrderModalLauncherBlockResolveConfig,
  groupedOrderModalLauncherBlockProperties,
} = doodBlockConfig(
  {
    name: "Modal launcher / Grouped order",
    componentType: 'GroupedOrderModalLauncherBlockComponent',
    category: 'content',
    description: "Modal launcher / Grouped order.",
    keywords: [],
    hideFromPicker: true,
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function groupedOrderModalLauncherBlockDescriptor(): IBlockDescriptor;
export function groupedOrderModalLauncherBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function groupedOrderModalLauncherBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedGroupedOrderModalLauncherBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedGroupedOrderModalLauncherBlockDescriptor, groupedOrderModalLauncherBlockProperties, fieldOrder);
}

export {
  groupedOrderModalLauncherBlockBlocDefinition,
  groupedOrderModalLauncherBlockDashboardLayout,
  groupedOrderModalLauncherBlockProperties,
  groupedOrderModalLauncherBlockConfig,
  groupedOrderModalLauncherBlockResolveConfig,
};

export type GroupedOrderModalLauncherBlockConfig = typeof groupedOrderModalLauncherBlockConfig;
